import { GlobalExclusionsAppGzDataProvider } from '../dataProvider/GlobalExclusionsAppGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';

export class GlobalExclusionsAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, GlobalExclusionsAppGzDataProvider);
  }
}
